import { render, staticRenderFns } from "./customizationAuthSection.vue?vue&type=template&id=08822c46"
import script from "./customizationAuthSection.vue?vue&type=script&lang=js"
export * from "./customizationAuthSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports